"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Admin_container_1 = require("./Admin.container");
exports.default = Admin_container_1.AdminContainer;
